(function () {
  if (window.__pcard4VariantFlowInit) return;
  window.__pcard4VariantFlowInit = true;

  document.addEventListener('click', (event) => {
    const closeBtn = event.target.closest('[data-pcard4-close]');
    if (closeBtn) {
      event.preventDefault();
      event.stopPropagation();

      const card = closeBtn.closest('.m-product-card--style-4');
      if (card) closeVariantPicker(card);
      return;
    }

    const revealBtn = event.target.closest('[data-pcard4-reveal]');
    if (revealBtn) {
      event.preventDefault();
      event.stopPropagation();

      const card = revealBtn.closest('.m-product-card--style-4');
      if (!card) return;

      if (card.classList.contains('m-product-card--variants-open')) {
        closeVariantPicker(card);
        return;
      }

      closeOtherVariantPickers(card);
      openVariantPicker(card, revealBtn);
      return;
    }

    closeVariantPickersOutside(event.target);

    const variantOption = event.target.closest(
      '.m-product-card--style-4 .m-product-option--node__label'
    );
    if (variantOption) {
      const card = variantOption.closest('.m-product-card--style-4');
      if (card) {
        window.requestAnimationFrame(() => syncFormVariantId(card));
      }
    }
  });

  function closeOtherVariantPickers(exceptCard) {
    document.querySelectorAll('.m-product-card--style-4.m-product-card--variants-open').forEach((card) => {
      if (card !== exceptCard) closeVariantPicker(card);
    });
  }

  function closeVariantPickersOutside(target) {
    document.querySelectorAll('.m-product-card--style-4.m-product-card--variants-open').forEach((card) => {
      if (!card.contains(target)) closeVariantPicker(card);
    });
  }

  function getFormVariantInput(card) {
    return (
      card.querySelector('product-form form [name="id"]') ||
      card.querySelector('form.product-card-form [name="id"]')
    );
  }

  function syncFormVariantId(card) {
    const idInput = getFormVariantInput(card);
    const swatch = card.querySelector('pcard-swatch');
    if (!idInput) return false;

    if (swatch && swatch.currentVariant && swatch.currentVariant.id) {
      idInput.value = String(swatch.currentVariant.id);
      idInput.setAttribute('value', String(swatch.currentVariant.id));
      return true;
    }

    const selectedLabel = card.querySelector(
      '[data-pcard-variant-picker] .m-product-option--node__label[data-selected="true"]'
    );
    if (selectedLabel && idInput.value) return true;

    return Boolean(idInput.value);
  }

  function openVariantPicker(card, revealBtn) {
    card.classList.add('m-product-card--variants-open');
    revealBtn.setAttribute('aria-expanded', 'true');

    const atcBtn = card.querySelector('[data-pcard4-atc]');
    if (atcBtn) atcBtn.disabled = true;

    selectDefaultVariant(card, 0, () => {
      syncFormVariantId(card);
      showAddToCartButton(card);
      if (atcBtn) atcBtn.disabled = false;
    });
  }

  function closeVariantPicker(card) {
    card.classList.remove('m-product-card--variants-open');
    card.classList.remove('m-product-card--variant-selected');

    const revealBtn = card.querySelector('[data-pcard4-reveal]');
    const atcBtn = card.querySelector('[data-pcard4-atc]');

    if (revealBtn) {
      revealBtn.removeAttribute('hidden');
      revealBtn.setAttribute('aria-expanded', 'false');
    }

    if (atcBtn) {
      atcBtn.setAttribute('hidden', 'hidden');
    }
  }

  function selectDefaultVariant(card, attempt = 0, onComplete) {
    const picker = card.querySelector('[data-pcard-variant-picker]');
    if (!picker) {
      if (onComplete) onComplete();
      return;
    }

    if (picker.querySelector('.m-product-option--node__label[data-selected="true"]')) {
      syncFormVariantId(card);
      if (onComplete) onComplete();
      return;
    }

    const firstOption = picker.querySelector('.m-product-option--node__label');
    if (!firstOption) {
      if (attempt < 12) {
        window.setTimeout(() => selectDefaultVariant(card, attempt + 1, onComplete), 80);
      } else if (onComplete) {
        onComplete();
      }
      return;
    }

    firstOption.dispatchEvent(new MouseEvent('click', { bubbles: true, cancelable: true }));

    if (picker.querySelector('.m-product-option--node__label[data-selected="true"]')) {
      syncFormVariantId(card);
      if (onComplete) onComplete();
    } else if (attempt < 12) {
      window.setTimeout(() => selectDefaultVariant(card, attempt + 1, onComplete), 80);
    } else if (onComplete) {
      onComplete();
    }
  }

  function showAddToCartButton(card) {
    const revealBtn = card.querySelector('[data-pcard4-reveal]');
    const atcBtn = card.querySelector('[data-pcard4-atc]');
    if (!revealBtn || !atcBtn) return;

    revealBtn.setAttribute('hidden', 'hidden');
    atcBtn.removeAttribute('hidden');
    card.classList.add('m-product-card--variant-selected');
  }

  function showZeroReviewBadges() {
    document.querySelectorAll('.m-product-card--style-4 .jdgm-prev-badge').forEach((badge) => {
      const reviewCount = Number(badge.dataset.numberOfReviews || 0);
      const avgRating = badge.dataset.averageRating;

      if (reviewCount > 0 && avgRating !== '0.00') return;

      badge.style.setProperty('display', 'inline-flex', 'important');

      let textEl = badge.querySelector('.jdgm-prev-badge__text');
      if (!textEl) {
        textEl = document.createElement('span');
        textEl.className = 'jdgm-prev-badge__text';
        badge.appendChild(textEl);
      }

      textEl.style.visibility = 'visible';

      if (!textEl.textContent.trim()) {
        textEl.textContent = ' 0 reviews ';
      }
    });

    document.querySelectorAll('.m-product-card--style-4 .m-product-card__reviews .jdgm-preview-badge').forEach((widget) => {
      widget.style.setProperty('display', 'block', 'important');
    });
  }

  function initReviewBadgeObserver() {
    showZeroReviewBadges();

    const reviewContainers = document.querySelectorAll('.m-product-card--style-4 .m-product-card__reviews');
    if (!reviewContainers.length) return;

    const observer = new MutationObserver(() => showZeroReviewBadges());
    reviewContainers.forEach((container) => {
      observer.observe(container, {
        childList: true,
        subtree: true,
        attributes: true,
        attributeFilter: ['style', 'data-number-of-reviews', 'data-average-rating'],
      });
    });

    window.addEventListener('load', showZeroReviewBadges);
    document.addEventListener('shopify:section:load', showZeroReviewBadges);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initReviewBadgeObserver);
  } else {
    initReviewBadgeObserver();
  }
})();
